const PROVIDER_LABELS: Record<string, string> = {
  BECKETT_GRADING: 'Beckett Grading',
  CELEBRITY_AUTHENTICS: 'Celebrity Authentics',
  GOAT: 'G.O.A.T. Authentics',
  GOATAUTHENTICS: 'G.O.A.T. Authentics',
  GRAD: 'Grad Authentication',
  ONLINEAUTHENTICS: 'Online Authentics',
  PSA_CARD: 'PSA CARD',
  PSA_DNA: 'PSA/DNA',
  SGC_GRADING: 'SGC',
  UPPERDECK: 'Upper Deck',
};

export function formatProviderLabel(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  return PROVIDER_LABELS[raw.toUpperCase()] || raw.replace(/_/g, ' ').replace(/\s+/g, ' ');
}

export function formatScanMethodLabel(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (!raw) return 'CheckCOA lookup';
  const normalized = raw.toLowerCase();
  if (normalized.includes('manual')) return 'Manual entry';
  if (normalized.startsWith('qr')) return 'QR scan';
  if (normalized.includes('ocr')) return 'Photo OCR';
  if (normalized.includes('camera')) return 'Camera scan';
  if (normalized.includes('upload')) return 'Photo upload';
  if (normalized === 'checkcoa') return 'CheckCOA lookup';

  const readable = normalized
    .replace(/^(?:web|mobile)_/, '')
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return readable
    ? readable.replace(/\b\w/g, (character) => character.toUpperCase())
    : 'CheckCOA lookup';
}
